import { render, staticRenderFns } from "./PipelineDataQuality.vue?vue&type=template&id=22349deb"
import script from "./PipelineDataQuality.vue?vue&type=script&lang=js"
export * from "./PipelineDataQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports